import { breakpointSmall } from 'lib/design-system';
import { useEffect, useState } from 'react';

const useIsMobileScreen = (size = breakpointSmall.end) => {
  const [isMobileScreen, setIsMobileScreen] = useState(true);

  useEffect(() => {
    const syncScreenType = () => {
      setIsMobileScreen(window.matchMedia(`(max-width: ${size})`).matches);
    };

    syncScreenType();

    window.addEventListener('resize', syncScreenType);

    return () => window.removeEventListener('resize', syncScreenType);
  }, [setIsMobileScreen, size]);

  return isMobileScreen;
};

export default useIsMobileScreen;
